
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');

      // console.log("testing: ", this.closest('cart-items'), this.closest('cart-drawer-items'));
      // console.log(cartItems);
      if(event.target.hasAttribute("data-upsellProduct")) {
        let upsellIds = event.target.dataset.upsellproduct;
        let data = {
          attributes: {
            'Upsell product': 'Removed'
          }
        };

        data.attributes['Upsell product'] = upsellIds;
        
        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(data)
        })
        .then(response => {
          if (response.ok) {
            return response.json();
          }
          throw new Error('Network response was not ok.');
        })
        .then(data => {
          cartItems.updateQuantity(this.dataset.index, 0);
        })
        .catch(error => {
          console.error('There was a problem updating cart attributes:', error);
        });
      } else {
        cartItems.updateQuantity(this.dataset.index, 0);
      }
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    // console.log(this);
    
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.debouncedOnRefresh = debounce((event) => {
      this.OnRefresh(event)
    }, 300);
    
    this.debouncedOnRefreshSingle = debounce((event) => {
      this.OnRefreshSingle(event)
    }, 100);
    
    // this.addEventListener('cart:refresh', this.debouncedOnRefresh.bind(this));
    // this.addEventListener('change', debouncedOnChange.bind(this));
    
    this.addEventListener('cart:refresh', function(e) {
      this.debouncedOnRefresh(e);
    }.bind(this));
    
    this.addEventListener('cart:refreshSingle', function(e) {
      this.debouncedOnRefreshSingle(e);
    }.bind(this));
    
    this.addEventListener('change', function(e) {
      debouncedOnChange(e);
    }.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    document.querySelector(".cart__ctas .button").setAttribute("disabled", true);
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name')); 
  }
  
  OnRefresh(e) {
    console.log("OnRefresh");
    fetch(window.Shopify.routes.root + "cart?view=drawer")
      .then((response) => {
        if (!response.ok) {
          console.log(response);
        }
        return response.text()
      })
      .then((responseText) => {
        // console.log("OnRefresh");
        let htmlData = new DOMParser().parseFromString(responseText, 'text/html');
  
        let drawer = htmlData.querySelector(`[data-modal=cart-drawer]`);
        let drawerItems = htmlData.querySelector("cart-drawer-items");
        let drawerCount = htmlData.querySelector("[data-cart-count]");
        let drawerButton = htmlData.querySelector(".cart__ctas");
        let drawerUpsell = htmlData.querySelector(".drawer__upsell");
        let drawerDiscounts = htmlData.querySelector(".saving-price");
        let drawerSubtotal = htmlData.querySelector(".subtotal");
        let cartbubble = htmlData.querySelector("#cart-icon-bubble");
  
        document.querySelector("cart-drawer-items").innerHTML = drawerItems.innerHTML;
        document.querySelector("[data-cart-count]").innerHTML = drawerCount.innerHTML;
        document.querySelector("#cart-icon-bubble").innerHTML = cartbubble.innerHTML;
        document.querySelector(".cart__ctas").innerHTML = drawerButton.innerHTML;
        document.querySelector(`[data-modal=cart-drawer]`).classList.toggle("is-empty", drawer.classList.contains("is-empty"));
        
        if( document.querySelector(".drawer__upsell")) {
          document.querySelector(".drawer__upsell").innerHTML = drawerUpsell.innerHTML;
        }
        // console.log("Update: ", drawerDiscounts, document.querySelector(".saving-price"));
        
        document.querySelector(".subtotal").innerHTML = drawerSubtotal.innerHTML;
        document.querySelector(".saving-price").innerHTML = drawerDiscounts.innerHTML;
  
        window.Custom.initSlider(`.drawer__upsell .swiper`);
        window.Custom.cartUpsellAuto();
        window.Custom.setCheckoutUtm();
      })
      .catch((error) => {
          console.error(error);
      });
  }

  OnRefreshSingle(e) {
    console.log("OnRefreshSingle");
    fetch(window.Shopify.routes.root + "cart?view=drawer")
      .then((response) => {
        if (!response.ok) {
          console.log(response);
        }
        return response.text()
      })
      .then((responseText) => {
        let htmlData = new DOMParser().parseFromString(responseText, 'text/html');
  
        let drawerItems = htmlData.querySelector("cart-drawer-items");
        let drawerCount = htmlData.querySelector("[data-cart-count]");
        let drawerButton = htmlData.querySelector(".cart__ctas");
        let drawerUpsell = htmlData.querySelector(".drawer__upsell");
        let drawerSubtotal = htmlData.querySelector(".subtotal");
        let cartbubble = htmlData.querySelector("#cart-icon-bubble");
        
        let drawerDiscounts = htmlData.querySelector(".saving-price");
        document.querySelector(".saving-price").innerHTML = drawerDiscounts.innerHTML;
        // console.log("Update: ", drawerDiscounts, document.querySelector(".saving-price"));
        
        document.querySelector("cart-drawer-items").innerHTML = drawerItems.innerHTML;
        document.querySelector("[data-cart-count]").innerHTML = drawerCount.innerHTML;
        document.querySelector("#cart-icon-bubble").innerHTML = cartbubble.innerHTML;
        // document.querySelector(".cart-count-bubble span:first-child").innerHTML = drawerCount.innerHTML;
        document.querySelector(".cart__ctas").innerHTML = drawerButton.innerHTML;
        
        if( document.querySelector(".drawer__upsell")) {
          document.querySelector(".drawer__upsell").innerHTML = drawerUpsell.innerHTML;
        }
        
        document.querySelector(".subtotal").innerHTML = drawerSubtotal.innerHTML;
        window.Custom.initSlider(`.drawer__upsell .swiper`);
        window.Custom.setCheckoutUtm();

        document.querySelector('#CartDrawer-Overlay').addEventListener('click', document.querySelector("cart-drawer").close.bind(document.querySelector("cart-drawer")));
      })
      .catch((error) => {
          console.error(error);
      });
  }
  
  onCartUpdate() {
    // console.log("onCartUpdate");
    fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');

        
        const sourceQty = html.querySelector('cart-items');
        if (sourceQty) {
          this.innerHTML = sourceQty.innerHTML;
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);
    console.log("updateQuantity");
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        
        window.Custom.cartUpsellAuto(null, parsedState);
        
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          // console.log(elementToReplace);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });
      })
      .catch((errorr) => {
        console.log("error:", errorr);
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
        
        window.Custom.updateCartErrorState("finally");
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    let htmlContent = new DOMParser().parseFromString(html, 'text/html');
    return htmlContent.querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    
    this.updateCartCustomContent();
  }
  
  updateCartCustomContent() {
    window.Custom.initSlider(`.drawer__upsell .swiper`);
    window.Custom.setCheckoutUtm();
  }

  setUpsellProductQty(callback) {
    
    let upsellProduct = document.querySelector("[data-upsell]");
    let upsellProductId = upsellProduct.dataset.upsell;

    if(upsellProduct) {
      fetch('/cart.js', { method: 'GET', headers: {'Content-Type': 'application/json;'}})
      .then((response) => {
        return response.json();
      }).then((cartObject) => {
        let sum = 0;
        let key = "";
        cartObject.items.forEach((el) => {
          if(el.id != upsellProductId) { 
            sum = 1;
          }
        });
        
        let updates = '?updates[' + upsellProductId + ']=' + sum;
        
        fetch('/cart/update.js' + updates, {
          method: 'POST'
        }).then(response => {
          callback();
        }).catch((error) => { });
      });
    } else {
      callback();
    }
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'change',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
